module.exports = __webpack_public_path__ + "static/media/sub-card-label-5.f49cd293.svg";